export const account = {
    state: {
        accounts: [],
    },
    mutations: {
        setAccounts(state, accounts) {
            state.accounts = accounts;
        },
    },
    getters: {
        getAccounts(state) {
            return state.accounts;
        },
    },
    actions: {},
};
